//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapGetters } from 'vuex'

export default {
  props: {
    row: {
      type: Object,
      default () {
        return {}
      }
    },
    currentDayIndex: {
      type: Number,
      default: null
    },
    selectedDays: {
      type: Array,
      default () {
        return []
      }
    },
    selectedRowIds: {
      type: Array,
      default () {
        return []
      }
    },
    showBrigades: {
      type: Boolean,
      default: false
    },
    showOvertimeTariffs: {
      type: Boolean,
      default: false
    },
    hideOtherWorkAreaOvertimes: {
      type: Boolean,
      default: false
    },
    getOvertimeTariffName: {
      type: Function,
      default: () => {}
    },
    isAnotherMonth: {
      type: Function,
      default: () => {}
    },
    overtimeTariffs: {
      type: Array,
      default () {
        return []
      }
    },
    additionalOvertimeTariffs: {
      type: Array,
      default () {
        return []
      }
    },
    overtimesGroupByValue: {
      type: Array,
      default () {
        return []
      }
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    }),
    hideOvertimes: function () {
      if (!this.user.employee || !this.user.employee.defaultWorkAreas || !this.hideOtherWorkAreaOvertimes) {
        return false
      }

      let hideOvertimes = true
      this.user.employee.defaultWorkAreas.forEach(workArea => {
        if (this.row && this.row.workArea && this.row.workArea.includes(workArea)) {
          hideOvertimes = false
        }
      })

      return hideOvertimes
    }
  },
  methods: {
    isCurrent: function (dayIndex) {
      return dayIndex === this.currentDayIndex
    },
    isSelectedDay: function (dayIndex) {
      return this.selectedDays.includes(dayIndex)
    },
    getOvertimeHoursByTariffId: function (overtimes, tariffId) {
      return overtimes && overtimes[tariffId] ? Math.round(overtimes[tariffId] / (1000 * 60 * 60) * 10) / 10 : 0
    }
  }
}

